import { Container, ContainerGutter, Text, TokenTextAppearance } from '@volkswagen-onehub/components-core';
import React, { useState } from 'react';
import styled from 'styled-components';

const DescriptionText = styled(Text)`
  font-weight: 700;
  font-style: Bold;
  leading-trim: NONE;
  line-height: 120%;
  letter-spacing: 0%;
  text-align: center;
  color: #ffffff;

  @media (max-width: 960px) {
    font-size: clamp(16px, 4vw, 20px);
  }

  @media (max-width: 560px) {
    font-size: clamp(15px, 4vw, 19px);
  }
`;

const SecondaryText = styled(Text)`
  font-weight: 300;
  font-style: Light;
  leading-trim: NONE;
  line-height: 120%;
  letter-spacing: 0%;
  text-align: center;
  color: #ffffff;

  @media (max-width: 960px) {
    font-size: clamp(14px, 3.5vw, 18px);
  }

  @media (max-width: 560px) {
    font-size: clamp(13px, 3.2vw, 17px);
  }
`;

const OptionsWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

const OptionsContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: clamp(15px, 5vw, 120px);

  @media (min-width: 961px) {
    margin-top: clamp(20px, 3vh, 50px);
  }

  @media (max-width: 960px) {
    gap: clamp(20px, 4vw, 30px);
    flex-direction: column;
    align-items: center;
  }

  @media (max-width: 560px) {
    gap: clamp(25px, 5vw, 35px);
  }
`;

const OptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const SvgContainer = styled.div<{ selected: boolean; order?: number; isError?: boolean; isCorrect?: boolean }>`
  width: clamp(200px, 18vw, 280px);
  height: clamp(30px, 2.6vw, 40px);

  svg {
    width: 100%;
    height: 100%;

    [stroke='#C90010'] {
      stroke: ${({ isCorrect }) => (isCorrect ? '#888888' : '#C90010')} !important;
    }

    [fill='#C90010'] {
      fill: ${({ isCorrect }) => (isCorrect ? '#888888' : '#C90010')} !important;
    }
  }
  cursor: pointer;
  position: relative;
  transition: transform 0.2s ease;

  ${({ selected, order, isError }) =>
    selected &&
    `
    &::after {
      content: '${isError ? '✕' : order}';
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: ${isError ? '#c90010' : 'white'};
      color: ${isError ? 'white' : '#c90010'};
      border-radius: 50%;
      width: clamp(24px, 3vw, 36px);
      height: clamp(24px, 3vw, 36px);
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      font-size: clamp(14px, 1.8vw, 20px);
    }
  `}
`;

const OptionText = styled(Text)<{ visible: boolean }>`
  font-family: 'VW Head', sans-serif;
  font-weight: 400;
  font-style: Regular;
  leading-trim: NONE;
  line-height: 120%;
  letter-spacing: 0%;
  text-align: center;
  color: #ffffff;
  margin-top: clamp(8px, 1vh, 15px);
  font-size: clamp(12px, 1.5vw, 18px);
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  transition: opacity 0.3s ease;
`;

const FeedbackContainer = styled.div`
  margin-top: clamp(20px, 3vh, 40px);
  height: clamp(50px, 7vh, 120px);
  width: 90vw;
  max-width: 600px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
`;

const FeedbackText = styled(Text)`
  weight: 700;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  color: #ffffff;
  padding: 0 clamp(5px, 1vw, 15px);
  font-size: clamp(14px, 1.4vw, 16px);

  @media (max-width: 560px) {
    padding: 0 clamp(8px, 2vw, 12px);
  }
`;

interface Question3Props {
  onAnswerSelected: (isCorrect: boolean) => void;
  handleIncorrect: () => void;
}

const options = [
  {
    id: 1,
    text: (
      <>
        MK3 <strong>1991</strong>
      </>
    ),
    svg: (
      <svg width="1919" height="232" viewBox="0 0 1919 232" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12.4082 218.079C-11.9245 99.119 49.5845 33.331 83.3806 15.3069C140.159 -0.914807 286.379 7.45473 343.605 15.3069C571.592 46.5834 514.226 225.999 343.605 226L12.4082 218.079Z"
          stroke="#C90010"
          strokeWidth="11.8168"
        />
        <circle cx="379.594" cy="126.101" r="74.3188" stroke="#C90010" strokeWidth="11.8168" />
        <circle cx="160.628" cy="116.006" r="30.8738" stroke="#C90010" strokeWidth="11.8168" />
        <path
          d="M1907.12 218.082C1931.46 99.1219 1869.95 33.3339 1836.15 15.3099C1779.37 -0.911878 1633.15 7.45765 1575.93 15.3099C1347.94 46.5863 1405.3 226.002 1575.93 226.003L1907.12 218.082Z"
          stroke="#C90010"
          strokeWidth="11.8168"
        />
        <circle
          cx="80.2272"
          cy="80.2272"
          r="74.3188"
          transform="matrix(-1 0 0 1 1620.16 45.877)"
          stroke="#C90010"
          strokeWidth="11.8168"
        />
        <circle
          cx="36.7822"
          cy="36.7822"
          r="30.8738"
          transform="matrix(-1 0 0 1 1795.69 79.2275)"
          stroke="#C90010"
          strokeWidth="11.8168"
        />
        <line x1="433.776" y1="39.9656" x2="1487.23" y2="39.9656" stroke="#C90010" strokeWidth="11.8168" />
        <path
          d="M485.02 83.7783L881.839 83.7784M1435.58 83.7784L1003.42 83.7784"
          stroke="#C90010"
          strokeWidth="11.8168"
        />
        <path
          d="M490.902 136.129L870.747 136.129M1425.69 136.129L1016.36 136.129"
          stroke="#C90010"
          strokeWidth="11.8168"
        />
        <path
          d="M475.355 173.692L886.441 173.692M1442.88 173.692L999.661 173.692"
          stroke="#C90010"
          strokeWidth="11.8168"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1022.3 126.106C1022.3 170.14 986.789 205.651 942.755 205.651C898.72 205.651 863.209 170.14 863.209 126.106C863.209 82.0715 898.72 46.5601 942.755 46.5601C986.789 46.5601 1022.3 82.0715 1022.3 126.106ZM942.127 107.411C942.253 107.664 942.379 107.916 942.758 107.916C943.137 107.916 943.263 107.664 943.389 107.411C943.453 107.285 943.516 107.159 943.61 107.064L965.485 59.9048C958.383 57.348 950.713 55.9275 942.758 55.9275C934.804 55.9275 927.133 57.348 920.031 59.9048L941.906 107.064C942.001 107.159 942.064 107.285 942.127 107.411ZM872.866 126.096C872.866 164.449 904.4 196.267 942.753 196.267C981.105 196.267 1012.64 164.449 1012.92 126.096C1012.92 117.858 1011.5 110.187 1008.95 103.085L968.037 182.631C967.469 183.767 966.901 184.619 965.48 184.619C964.06 184.619 963.492 183.767 962.923 182.631L943.605 140.301C943.51 140.206 943.447 140.08 943.384 139.954C943.258 139.701 943.132 139.449 942.753 139.449C942.469 139.449 942.185 139.733 941.901 140.301L922.866 182.631C922.298 183.767 921.73 184.619 920.31 184.619C918.889 184.619 918.321 183.767 917.753 182.631L876.844 103.085C874.287 110.471 872.866 118.142 872.866 126.096ZM919.741 159.053C919.363 159.053 919.236 158.8 919.11 158.548C919.047 158.422 918.984 158.295 918.889 158.201L883.094 89.4506C889.344 79.2233 898.434 70.7005 908.946 64.7346L934.23 119.28C934.798 120.417 935.366 120.701 936.219 120.701H949.287C950.139 120.701 950.707 120.417 951.276 119.28L976.276 64.7346C986.787 70.7005 995.878 79.2233 1002.13 89.4506L966.616 158.201C966.332 158.769 966.048 159.053 965.764 159.053C965.385 159.053 965.259 158.8 965.133 158.548C965.07 158.422 965.007 158.295 964.912 158.201L951.276 128.087C950.707 126.951 950.139 126.667 949.287 126.667H936.219C935.366 126.667 934.798 126.951 934.23 128.087L920.594 158.201C920.499 158.295 920.436 158.422 920.373 158.548C920.246 158.8 920.12 159.053 919.741 159.053Z"
          fill="#C90010"
        />
      </svg>
    ),
  },
  {
    id: 2,
    text: (
      <>
        MK1 <strong>1976</strong>
      </>
    ),
    svg: (
      <svg width="1415" height="248" viewBox="0 0 1415 248" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M65.3426 220.829H6.58203V26.44C6.58203 15.6 15.3695 6.8125 26.2095 6.8125H1389.25C1400.09 6.8125 1408.88 15.6 1408.88 26.44V220.829H1350.03"
          stroke="#C90010"
          strokeWidth="11.8168"
        />
        <line x1="316.861" y1="36.804" x2="1098.6" y2="36.804" stroke="#C90010" strokeWidth="11.8168" />
        <line x1="316.861" y1="59.2063" x2="1098.6" y2="59.2063" stroke="#C90010" strokeWidth="11.8168" />
        <path d="M316.861 82.3564H663.067M1098.6 82.3564H752.128" stroke="#C90010" strokeWidth="11.8168" />
        <path d="M316.861 108.725H641.284M1098.6 108.725H772.731" stroke="#C90010" strokeWidth="11.8168" />
        <path d="M316.861 135.786H633.297M1098.6 135.786H779.997" stroke="#C90010" strokeWidth="11.8168" />
        <path d="M316.861 162.154H636.219M1098.6 162.154H778.536" stroke="#C90010" strokeWidth="11.8168" />
        <path d="M316.861 188.538H649.343M1098.6 188.538H764.184" stroke="#C90010" strokeWidth="11.8168" />
        <path d="M316.861 216.896H764.184H1098.6" stroke="#C90010" strokeWidth="11.8168" />
        <line x1="318.941" y1="240.442" x2="1100.68" y2="240.442" stroke="#C90010" strokeWidth="11.8168" />
        <path d="M120.291 36.6533H316.862V240.472L218.576 240.967H120.291" stroke="#C90010" strokeWidth="11.8168" />
        <circle cx="128.874" cy="138.782" r="102.52" stroke="#C90010" strokeWidth="11.8168" />
        <circle
          cx="128.869"
          cy="138.745"
          r="50.8928"
          transform="rotate(-180 128.869 138.745)"
          stroke="#C90010"
          strokeWidth="11.8168"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M786.876 141.631C786.876 185.445 751.543 220.778 707.729 220.778C663.916 220.778 628.582 185.445 628.582 141.631C628.582 97.8174 663.916 62.4839 707.729 62.4839C751.543 62.4839 786.876 97.8174 786.876 141.631ZM707.099 123.039C707.225 123.29 707.351 123.541 707.727 123.541C708.104 123.541 708.23 123.29 708.356 123.039C708.418 122.913 708.481 122.788 708.575 122.693L730.341 75.7705C723.274 73.2265 715.642 71.8132 707.727 71.8132C699.813 71.8132 692.181 73.2265 685.114 75.7705L706.879 122.693C706.974 122.788 707.036 122.913 707.099 123.039ZM638.195 141.636C638.195 179.797 669.572 211.456 707.732 211.456C745.892 211.456 777.268 179.797 777.551 141.636C777.551 133.439 776.138 125.807 773.594 118.74L732.889 197.887C732.324 199.018 731.759 199.866 730.345 199.866C728.932 199.866 728.367 199.018 727.801 197.887L708.58 155.77C708.486 155.676 708.423 155.55 708.36 155.424C708.234 155.173 708.109 154.922 707.732 154.922C707.449 154.922 707.167 155.205 706.884 155.77L687.945 197.887C687.38 199.018 686.814 199.866 685.401 199.866C683.988 199.866 683.422 199.018 682.857 197.887L642.153 118.74C639.609 126.09 638.195 133.722 638.195 141.636ZM684.836 174.428C684.459 174.428 684.334 174.177 684.208 173.926C684.145 173.8 684.082 173.675 683.988 173.58L648.372 105.175C654.591 94.9985 663.636 86.5185 674.095 80.5825L699.252 134.855C699.818 135.985 700.383 136.268 701.231 136.268H714.234C715.082 136.268 715.647 135.985 716.212 134.855L741.087 80.5825C751.546 86.5185 760.591 94.9985 766.81 105.175L731.476 173.58C731.194 174.146 730.911 174.428 730.628 174.428C730.251 174.428 730.126 174.177 730 173.926C729.937 173.8 729.875 173.675 729.78 173.58L716.212 143.617C715.647 142.487 715.082 142.204 714.234 142.204H701.231C700.383 142.204 699.818 142.487 699.252 143.617L685.684 173.58C685.59 173.675 685.527 173.8 685.464 173.926C685.339 174.177 685.213 174.428 684.836 174.428Z"
          fill="#C90010"
        />
        <path d="M1298.24 36.729H1101.67V240.548L1199.96 241.042H1298.24" stroke="#C90010" strokeWidth="11.8168" />
        <circle
          cx="108.429"
          cy="108.429"
          r="102.52"
          transform="matrix(-1 0 0 1 1398.08 30.4297)"
          stroke="#C90010"
          strokeWidth="11.8168"
        />
        <circle
          cx="56.8012"
          cy="56.8012"
          r="50.8928"
          transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 1232.86 195.622)"
          stroke="#C90010"
          strokeWidth="11.8168"
        />
      </svg>
    ),
  },
  {
    id: 3,
    text: (
      <>
        MK5 <strong>2004</strong>
      </>
    ),
    svg: (
      <svg width="1680" height="244" viewBox="0 0 1680 244" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M37.4273 203.02L30.9395 164.084L352.16 184.635V228.978" stroke="#C90010" strokeWidth="11.8168" />
        <path
          d="M6.13959 207.888C5.4365 145.269 24.6364 13.3203 87.1141 8.25441C165.211 1.92204 353.358 65.6046 382.617 111.68C411.877 157.756 412.589 238.325 312.963 229.882C213.336 221.44 69.4617 206.726 6.13959 201.097"
          stroke="#C90010"
          strokeWidth="11.8168"
        />
        <circle cx="126.295" cy="97.129" r="72.3451" stroke="#C90010" strokeWidth="11.8168" />
        <circle cx="283.16" cy="119.151" r="61.6896" stroke="#C90010" strokeWidth="11.8168" />
        <circle cx="126.295" cy="91.4169" r="44.572" stroke="#C90010" strokeWidth="11.8168" />
        <path d="M1642.26 201.499L1648.75 162.563L1327.53 183.114V227.457" stroke="#C90010" strokeWidth="11.8168" />
        <path
          d="M1673.55 206.364C1674.25 143.746 1655.05 11.7964 1592.57 6.73049C1514.47 0.398116 1326.33 64.0807 1297.07 110.156C1267.81 156.232 1267.1 236.802 1366.72 228.359C1466.35 219.916 1610.22 205.202 1673.55 199.573"
          stroke="#C90010"
          strokeWidth="11.8168"
        />
        <circle
          cx="78.2535"
          cy="78.2535"
          r="72.3451"
          transform="matrix(-1 0 0 1 1631.64 17.3516)"
          stroke="#C90010"
          strokeWidth="11.8168"
        />
        <circle
          cx="67.598"
          cy="67.598"
          r="61.6896"
          transform="matrix(-1 0 0 1 1464.12 50.0288)"
          stroke="#C90010"
          strokeWidth="11.8168"
        />
        <circle
          cx="50.4804"
          cy="50.4804"
          r="44.572"
          transform="matrix(-1 0 0 1 1603.87 39.4121)"
          stroke="#C90010"
          strokeWidth="11.8168"
        />
        <path
          d="M399.773 142.596L776.294 142.596M1279.91 142.596L898.185 142.596"
          stroke="#C90010"
          strokeWidth="11.8168"
        />
        <path
          d="M379.571 109.35L822.466 109.351M1299.43 109.334L869.969 109.334"
          stroke="#C90010"
          strokeWidth="11.8168"
        />
        <path d="M392.411 190.62H774.651M1288.36 190.62H902.641" stroke="#C90010" strokeWidth="11.8168" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M910.885 171.185C910.885 211.351 878.493 243.744 838.326 243.744C798.159 243.744 765.767 211.351 765.767 171.185C765.767 131.018 798.159 98.6255 838.326 98.6255C878.493 98.6255 910.885 131.018 910.885 171.185ZM837.754 154.145C837.869 154.375 837.985 154.606 838.33 154.606C838.676 154.606 838.791 154.375 838.906 154.145C838.964 154.03 839.021 153.915 839.108 153.828L859.061 110.811C852.583 108.479 845.586 107.183 838.33 107.183C831.074 107.183 824.077 108.479 817.599 110.811L837.553 153.828C837.639 153.915 837.697 154.03 837.754 154.145ZM774.577 171.179C774.577 206.163 803.342 235.187 838.326 235.187C873.31 235.187 902.074 206.163 902.333 171.179C902.333 163.664 901.038 156.667 898.705 150.189L861.389 222.748C860.871 223.785 860.353 224.562 859.057 224.562C857.761 224.562 857.243 223.785 856.725 222.748L839.103 184.136C839.017 184.05 838.959 183.935 838.902 183.819C838.786 183.589 838.671 183.359 838.326 183.359C838.067 183.359 837.807 183.618 837.548 184.136L820.186 222.748C819.668 223.785 819.149 224.562 817.854 224.562C816.558 224.562 816.04 223.785 815.521 222.748L778.205 150.189C775.873 156.926 774.577 163.923 774.577 171.179ZM817.342 201.238C816.996 201.238 816.881 201.007 816.766 200.777C816.708 200.662 816.651 200.547 816.564 200.46L783.913 137.748C789.614 128.419 797.906 120.645 807.494 115.203L830.558 164.958C831.076 165.995 831.594 166.254 832.372 166.254H844.292C845.07 166.254 845.588 165.995 846.106 164.958L868.91 115.203C878.499 120.645 886.791 128.419 892.492 137.748L860.1 200.46C859.841 200.979 859.581 201.238 859.322 201.238C858.977 201.238 858.862 201.007 858.746 200.777C858.689 200.662 858.631 200.547 858.545 200.46L846.106 172.991C845.588 171.955 845.07 171.696 844.292 171.696H832.372C831.594 171.696 831.076 171.955 830.558 172.991L818.119 200.46C818.033 200.547 817.975 200.662 817.917 200.777C817.802 201.007 817.687 201.238 817.342 201.238Z"
          fill="#C90010"
        />
        <path
          d="M879.733 221.299C876.47 221.299 873.824 223.945 873.824 227.208C873.824 230.471 876.47 233.116 879.733 233.116V227.208V221.299ZM796.503 233.116C799.767 233.116 802.412 230.471 802.412 227.208C802.412 223.945 799.767 221.299 796.503 221.299V227.208V233.116ZM1173.08 206.034L1169.43 201.386L1173.08 206.034ZM484.671 201.635L480.712 206.021L484.671 201.635ZM376.358 103.872L372.4 108.258L480.712 206.021L484.671 201.635L488.63 197.249L380.317 99.4861L376.358 103.872ZM1173.08 206.034L1176.73 210.682L1302.78 111.756L1299.13 107.108L1295.48 102.46L1169.43 201.386L1173.08 206.034ZM879.733 227.208V233.116H1111.8V227.208V221.299H879.733V227.208ZM551.171 227.208V233.116H796.503V227.208V221.299H551.171V227.208ZM1173.08 206.034L1169.43 201.386C1152.99 214.287 1132.7 221.299 1111.8 221.299V227.208V233.116C1135.35 233.116 1158.21 225.217 1176.73 210.682L1173.08 206.034ZM484.671 201.635L480.712 206.021C500.035 223.462 525.141 233.116 551.171 233.116V227.208V221.299C528.066 221.299 505.782 212.73 488.63 197.249L484.671 201.635Z"
          fill="#C90010"
        />
      </svg>
    ),
  },
  {
    id: 4,
    text: (
      <>
        MK2 <strong>1984</strong>
      </>
    ),
    svg: (
      <svg width="1620" height="242" viewBox="0 0 1620 242" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1405.51 207.151L1417.3 218.969H186.91L200.929 207.151H1405.51Z" fill="#C90010" />
        <path
          d="M1607.47 187.146V32.6359C1607.47 21.5864 1598.51 12.6305 1587.46 12.6305H32.7883C21.7392 12.6311 12.7834 21.5869 12.7828 32.6359V187.146C12.7833 198.195 21.7391 207.15 32.7883 207.151V218.969C15.7622 218.968 1.85894 205.598 1.00596 188.784L0.964844 187.146V32.6359C0.965436 15.0606 15.2129 0.813102 32.7883 0.8125H1587.46C1605.04 0.8125 1619.29 15.0602 1619.29 32.6359V187.146L1619.25 188.784C1618.39 205.598 1604.49 218.969 1587.46 218.969V207.151C1598.51 207.151 1607.47 198.195 1607.47 187.146Z"
          fill="#C90010"
        />
        <path d="M1546.5 207.151H1587.46V218.969H1535.65L1546.5 207.151Z" fill="#C90010" />
        <path d="M62.3368 207.151L72.1503 218.969H32.7883V207.151H62.3368Z" fill="#C90010" />
        <circle cx="129.618" cy="129.713" r="105.602" stroke="#C90010" strokeWidth="11.8168" />
        <circle cx="1476.89" cy="129.713" r="105.602" stroke="#C90010" strokeWidth="11.8168" />
        <line x1="254.99" y1="2.2959" x2="254.99" y2="213.862" stroke="#C90010" strokeWidth="11.8168" />
        <path
          d="M1345.86 49.1626L1278.15 49.1626M257.036 49.1626L324.832 49.1626M1166.14 49.1626L839.142 49.1626M436.838 49.1626L756.026 49.1626"
          stroke="#C90010"
          strokeWidth="15.9123"
        />
        <path
          d="M1345.86 88.9429H1301.54M257.036 88.9429H299.89M1142.24 88.9429L867.005 88.9429M459.374 88.9429L726.203 88.9429"
          stroke="#C90010"
          strokeWidth="15.9123"
        />
        <path
          d="M1345.86 128.723H1301.04M257.036 128.723H299.336M1141.25 128.723L866.494 128.723M459.374 128.723L726.203 128.723"
          stroke="#C90010"
          strokeWidth="15.9123"
        />
        <path
          d="M1345.86 168.503H1280.14M257.036 168.503L323.148 168.503M1163.15 168.503L842.517 168.503M438.331 168.503L753.751 168.503"
          stroke="#C90010"
          strokeWidth="15.9123"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M875.988 109.896C875.988 153.293 840.99 188.291 797.592 188.291C754.195 188.291 719.197 153.293 719.197 109.896C719.197 66.4984 754.195 31.5005 797.592 31.5005C840.99 31.5005 875.988 66.4984 875.988 109.896ZM796.967 91.4879C797.092 91.7368 797.216 91.9857 797.589 91.9857C797.963 91.9857 798.087 91.7368 798.211 91.4879C798.274 91.3635 798.336 91.2391 798.429 91.1458L819.987 44.6705C812.988 42.1507 805.429 40.7509 797.589 40.7509C789.75 40.7509 782.191 42.1507 775.192 44.6705L796.749 91.1458C796.843 91.2391 796.905 91.3635 796.967 91.4879ZM728.729 109.889C728.729 147.686 759.807 179.044 797.605 179.044C835.403 179.044 866.481 147.686 866.761 109.889C866.761 101.769 865.361 94.2096 862.841 87.21L822.523 165.605C821.963 166.725 821.403 167.565 820.004 167.565C818.604 167.565 818.044 166.725 817.484 165.605L798.445 123.888C798.352 123.794 798.289 123.67 798.227 123.546C798.103 123.297 797.978 123.048 797.605 123.048C797.325 123.048 797.045 123.328 796.765 123.888L778.006 165.605C777.446 166.725 776.886 167.565 775.486 167.565C774.086 167.565 773.526 166.725 772.966 165.605L732.649 87.21C730.129 94.4895 728.729 102.049 728.729 109.889ZM774.914 142.382C774.54 142.382 774.416 142.133 774.291 141.884C774.229 141.76 774.167 141.636 774.074 141.542L738.797 73.7891C744.957 63.7101 753.916 55.311 764.275 49.4316L789.192 103.186C789.752 104.306 790.312 104.586 791.152 104.586H804.031C804.871 104.586 805.431 104.306 805.99 103.186L830.628 49.4316C840.987 55.311 849.946 63.7101 856.105 73.7891L821.109 141.542C820.829 142.102 820.549 142.382 820.269 142.382C819.896 142.382 819.771 142.133 819.647 141.884C819.585 141.76 819.522 141.636 819.429 141.542L805.99 111.865C805.431 110.745 804.871 110.465 804.031 110.465H791.152C790.312 110.465 789.752 110.745 789.192 111.865L775.753 141.542C775.66 141.636 775.598 141.76 775.536 141.884C775.411 142.133 775.287 142.382 774.914 142.382Z"
          fill="#C90010"
        />
        <path
          d="M798.211 91.4879L796.763 90.7638L796.763 90.7639L798.211 91.4879ZM798.429 91.1458L799.574 92.2907L799.777 92.0876L799.898 91.8271L798.429 91.1458ZM819.987 44.6705L821.456 45.3518L822.201 43.7464L820.536 43.147L819.987 44.6705ZM775.192 44.6705L774.643 43.147L772.978 43.7464L773.723 45.3518L775.192 44.6705ZM796.749 91.1458L795.281 91.8271L795.401 92.0876L795.604 92.2907L796.749 91.1458ZM866.761 109.889L868.38 109.901V109.889H866.761ZM862.841 87.21L864.364 86.6615L863.104 83.1591L861.401 86.4695L862.841 87.21ZM822.523 165.605L821.083 164.865L821.079 164.873L821.075 164.881L822.523 165.605ZM817.484 165.605L816.011 166.277L816.023 166.304L816.035 166.329L817.484 165.605ZM798.445 123.888L799.918 123.215L799.797 122.95L799.59 122.743L798.445 123.888ZM796.765 123.888L795.317 123.164L795.302 123.193L795.288 123.224L796.765 123.888ZM778.006 165.605L779.454 166.329L779.469 166.3L779.483 166.269L778.006 165.605ZM772.966 165.605L774.415 164.881L774.411 164.873L774.406 164.865L772.966 165.605ZM732.649 87.21L734.089 86.4695L732.357 83.1026L731.119 86.6803L732.649 87.21ZM774.074 141.542L772.638 142.29L772.753 142.511L772.929 142.687L774.074 141.542ZM738.797 73.7891L737.416 72.9448L736.939 73.7254L737.361 74.5368L738.797 73.7891ZM764.275 49.4316L765.744 48.7506L765.004 47.1556L763.475 48.0234L764.275 49.4316ZM789.192 103.186L787.723 103.867L787.733 103.889L787.744 103.91L789.192 103.186ZM805.99 103.186L807.439 103.91L807.451 103.886L807.462 103.861L805.99 103.186ZM830.628 49.4316L831.427 48.0234L829.892 47.1519L829.156 48.7569L830.628 49.4316ZM856.105 73.7891L857.544 74.5322L857.962 73.7224L857.487 72.9448L856.105 73.7891ZM821.109 141.542L819.67 140.799L819.665 140.809L819.661 140.818L821.109 141.542ZM819.647 141.884L818.199 142.608L818.199 142.609L819.647 141.884ZM819.429 141.542L817.954 142.21L818.076 142.479L818.284 142.687L819.429 141.542ZM805.99 111.865L807.465 111.197L807.453 111.169L807.439 111.141L805.99 111.865ZM789.192 111.865L787.744 111.141L787.73 111.169L787.717 111.197L789.192 111.865ZM775.753 141.542L776.898 142.687L777.107 142.479L777.228 142.21L775.753 141.542ZM797.592 188.291V189.91C841.884 189.91 877.607 154.187 877.607 109.896H875.988H874.369C874.369 152.399 840.096 186.672 797.592 186.672V188.291ZM719.197 109.896H717.578C717.578 154.187 753.301 189.91 797.592 189.91V188.291V186.672C755.089 186.672 720.816 152.399 720.816 109.896H719.197ZM797.592 31.5005V29.8813C753.301 29.8813 717.578 65.6041 717.578 109.896H719.197H720.816C720.816 67.3926 755.089 33.1196 797.592 33.1196V31.5005ZM875.988 109.896H877.607C877.607 65.6041 841.884 29.8813 797.592 29.8813V31.5005V33.1196C840.096 33.1196 874.369 67.3926 874.369 109.896H875.988ZM797.589 91.9857V90.3665C797.68 90.3665 797.815 90.3825 797.969 90.4457C798.124 90.5097 798.245 90.6 798.33 90.6852C798.408 90.7634 798.447 90.8279 798.453 90.8377C798.455 90.8418 798.452 90.8363 798.415 90.7638L796.967 91.4879L795.519 92.2121C795.556 92.2852 795.727 92.6624 796.04 92.9751C796.44 93.3755 796.978 93.6048 797.589 93.6048V91.9857ZM798.211 91.4879L796.763 90.7639C796.727 90.8363 796.723 90.8419 796.726 90.8377C796.732 90.8279 796.771 90.7634 796.849 90.6852C796.934 90.6 797.055 90.5097 797.21 90.4457C797.364 90.3825 797.499 90.3665 797.589 90.3665V91.9857V93.6048C798.201 93.6048 798.738 93.3755 799.139 92.975C799.451 92.6624 799.623 92.2852 799.66 92.212L798.211 91.4879ZM798.429 91.1458L797.284 90.0008C796.972 90.3134 796.8 90.6907 796.763 90.7638L798.211 91.4879L799.66 92.2121C799.676 92.1786 799.685 92.1612 799.693 92.1464C799.7 92.133 799.701 92.1321 799.697 92.1382C799.691 92.148 799.652 92.2125 799.574 92.2907L798.429 91.1458ZM819.987 44.6705L818.518 43.9891L796.96 90.4644L798.429 91.1458L799.898 91.8271L821.456 45.3518L819.987 44.6705ZM797.589 40.7509V42.37C805.235 42.37 812.609 43.7353 819.439 46.1939L819.987 44.6705L820.536 43.147C813.366 40.5662 805.622 39.1317 797.589 39.1317V40.7509ZM775.192 44.6705L775.74 46.1939C782.57 43.7353 789.944 42.37 797.589 42.37V40.7509V39.1317C789.557 39.1317 781.812 40.5662 774.643 43.147L775.192 44.6705ZM796.749 91.1458L798.218 90.4644L776.66 43.9891L775.192 44.6705L773.723 45.3518L795.281 91.8271L796.749 91.1458ZM796.967 91.4879L798.415 90.7638C798.379 90.6907 798.207 90.3134 797.894 90.0008L796.749 91.1458L795.604 92.2907C795.526 92.2125 795.487 92.148 795.482 92.1382C795.478 92.1321 795.479 92.133 795.486 92.1464C795.493 92.1612 795.502 92.1786 795.519 92.2121L796.967 91.4879ZM797.605 179.044V177.425C760.71 177.425 730.348 146.801 730.348 109.889H728.729H727.11C727.11 148.572 758.904 180.664 797.605 180.664V179.044ZM866.761 109.889L865.142 109.877C864.868 146.8 834.498 177.425 797.605 177.425V179.044V180.664C836.308 180.664 868.093 148.572 868.38 109.901L866.761 109.889ZM862.841 87.21L861.317 87.7584C863.775 94.5849 865.142 101.959 865.142 109.889H866.761H868.38C868.38 101.579 866.947 93.8342 864.364 86.6615L862.841 87.21ZM822.523 165.605L823.963 166.346L864.281 87.9505L862.841 87.21L861.401 86.4695L821.083 164.865L822.523 165.605ZM820.004 167.565V169.184C821.078 169.184 821.964 168.842 822.668 168.203C823.296 167.632 823.688 166.896 823.972 166.329L822.523 165.605L821.075 164.881C820.799 165.434 820.631 165.678 820.489 165.807C820.436 165.856 820.392 165.881 820.343 165.899C820.291 165.919 820.189 165.946 820.004 165.946V167.565ZM817.484 165.605L816.035 166.329C816.319 166.896 816.711 167.632 817.339 168.203C818.043 168.842 818.929 169.184 820.004 169.184V167.565V165.946C819.818 165.946 819.716 165.919 819.664 165.899C819.615 165.881 819.571 165.856 819.518 165.807C819.376 165.678 819.208 165.434 818.932 164.881L817.484 165.605ZM798.445 123.888L796.972 124.56L816.011 166.277L817.484 165.605L818.957 164.933L799.918 123.215L798.445 123.888ZM798.227 123.546L796.779 124.27C796.815 124.343 796.987 124.72 797.3 125.033L798.445 123.888L799.59 122.743C799.668 122.821 799.707 122.885 799.713 122.895C799.716 122.901 799.716 122.901 799.709 122.887C799.701 122.872 799.692 122.855 799.675 122.821L798.227 123.546ZM797.605 123.048V124.667C797.514 124.667 797.379 124.651 797.226 124.588C797.07 124.524 796.95 124.433 796.864 124.348C796.786 124.27 796.747 124.206 796.741 124.196C796.739 124.192 796.743 124.197 796.779 124.27L798.227 123.546L799.675 122.821C799.639 122.748 799.467 122.371 799.154 122.058C798.754 121.658 798.216 121.429 797.605 121.429V123.048ZM796.765 123.888L798.213 124.612C798.315 124.408 798.363 124.37 798.33 124.403C798.293 124.439 798.046 124.667 797.605 124.667V123.048V121.429C796.884 121.429 796.356 121.796 796.04 122.113C795.727 122.426 795.495 122.807 795.317 123.164L796.765 123.888ZM778.006 165.605L779.483 166.269L798.242 124.552L796.765 123.888L795.288 123.224L776.529 164.941L778.006 165.605ZM775.486 167.565V169.184C776.561 169.184 777.447 168.842 778.15 168.203C778.779 167.632 779.171 166.896 779.454 166.329L778.006 165.605L776.558 164.881C776.281 165.434 776.113 165.678 775.972 165.807C775.919 165.856 775.875 165.881 775.826 165.899C775.774 165.919 775.672 165.946 775.486 165.946V167.565ZM772.966 165.605L771.518 166.329C771.802 166.896 772.194 167.632 772.822 168.203C773.525 168.842 774.412 169.184 775.486 169.184V167.565V165.946C775.301 165.946 775.198 165.919 775.146 165.899C775.098 165.881 775.054 165.856 775.001 165.807C774.859 165.678 774.691 165.434 774.415 164.881L772.966 165.605ZM732.649 87.21L731.209 87.9505L771.527 166.346L772.966 165.605L774.406 164.865L734.089 86.4695L732.649 87.21ZM728.729 109.889H730.348C730.348 102.245 731.713 94.8647 734.179 87.7396L732.649 87.21L731.119 86.6803C728.545 94.1143 727.11 101.853 727.11 109.889H728.729ZM774.291 141.884L772.843 142.609C772.88 142.682 773.052 143.059 773.364 143.372C773.765 143.772 774.302 144.001 774.914 144.001V142.382V140.763C775.004 140.763 775.139 140.779 775.293 140.842C775.448 140.906 775.569 140.997 775.654 141.082C775.732 141.16 775.771 141.224 775.777 141.234C775.78 141.238 775.776 141.233 775.74 141.16L774.291 141.884ZM774.074 141.542L772.929 142.687C772.851 142.609 772.812 142.545 772.806 142.535C772.802 142.529 772.803 142.529 772.81 142.543C772.818 142.558 772.826 142.575 772.843 142.609L774.291 141.884L775.74 141.16C775.703 141.087 775.531 140.71 775.219 140.397L774.074 141.542ZM738.797 73.7891L737.361 74.5368L772.638 142.29L774.074 141.542L775.51 140.795L740.233 73.0414L738.797 73.7891ZM764.275 49.4316L763.475 48.0234C752.895 54.0285 743.728 62.615 737.416 72.9448L738.797 73.7891L740.179 74.6334C746.185 64.8052 754.936 56.5935 765.074 50.8397L764.275 49.4316ZM789.192 103.186L790.661 102.505L765.744 48.7506L764.275 49.4316L762.806 50.1125L787.723 103.867L789.192 103.186ZM791.152 104.586V102.967C790.917 102.967 790.921 102.929 790.965 102.959C790.98 102.968 790.858 102.897 790.64 102.462L789.192 103.186L787.744 103.91C788.087 104.596 788.525 105.224 789.169 105.653C789.843 106.103 790.547 106.205 791.152 106.205V104.586ZM804.031 104.586V102.967H791.152V104.586V106.205H804.031V104.586ZM805.99 103.186L804.542 102.462C804.325 102.897 804.203 102.968 804.217 102.959C804.262 102.929 804.266 102.967 804.031 102.967V104.586V106.205C804.636 106.205 805.339 106.103 806.014 105.653C806.658 105.224 807.096 104.596 807.439 103.91L805.99 103.186ZM830.628 49.4316L829.156 48.7569L804.519 102.512L805.99 103.186L807.462 103.861L832.1 50.1062L830.628 49.4316ZM856.105 73.7891L857.487 72.9448C851.174 62.615 842.008 54.0285 831.427 48.0234L830.628 49.4316L829.829 50.8397C839.966 56.5935 848.718 64.8052 854.724 74.6334L856.105 73.7891ZM821.109 141.542L822.548 142.285L857.544 74.5322L856.105 73.7891L854.667 73.046L819.67 140.799L821.109 141.542ZM820.269 142.382V144.001C820.99 144.001 821.517 143.634 821.834 143.317C822.147 143.004 822.379 142.623 822.557 142.266L821.109 141.542L819.661 140.818C819.559 141.022 819.511 141.06 819.544 141.027C819.581 140.991 819.828 140.763 820.269 140.763V142.382ZM819.647 141.884L818.199 142.609C818.235 142.682 818.407 143.059 818.72 143.372C819.12 143.772 819.658 144.001 820.269 144.001V142.382V140.763C820.36 140.763 820.495 140.779 820.648 140.842C820.804 140.906 820.924 140.997 821.01 141.082C821.088 141.16 821.127 141.224 821.132 141.234C821.135 141.238 821.131 141.233 821.095 141.16L819.647 141.884ZM819.429 141.542L818.284 142.687C818.206 142.609 818.167 142.545 818.161 142.535C818.158 142.529 818.158 142.529 818.165 142.543C818.173 142.558 818.182 142.575 818.199 142.608L819.647 141.884L821.095 141.16C821.058 141.087 820.887 140.71 820.574 140.397L819.429 141.542ZM805.99 111.865L804.515 112.533L817.954 142.21L819.429 141.542L820.904 140.874L807.465 111.197L805.99 111.865ZM804.031 110.465V112.085C804.266 112.085 804.262 112.122 804.217 112.093C804.203 112.083 804.325 112.155 804.542 112.589L805.99 111.865L807.439 111.141C807.096 110.456 806.658 109.828 806.014 109.398C805.339 108.949 804.636 108.846 804.031 108.846V110.465ZM791.152 110.465V112.085H804.031V110.465V108.846H791.152V110.465ZM789.192 111.865L790.64 112.589C790.858 112.155 790.98 112.083 790.965 112.093C790.921 112.122 790.917 112.085 791.152 112.085V110.465V108.846C790.547 108.846 789.843 108.949 789.169 109.398C788.525 109.828 788.087 110.456 787.744 111.141L789.192 111.865ZM775.753 141.542L777.228 142.21L790.667 112.533L789.192 111.865L787.717 111.197L774.279 140.874L775.753 141.542ZM775.536 141.884L776.984 142.609C777.001 142.575 777.009 142.558 777.017 142.543C777.024 142.529 777.025 142.529 777.021 142.535C777.015 142.545 776.977 142.609 776.898 142.687L775.753 141.542L774.609 140.397C774.296 140.71 774.124 141.087 774.088 141.16L775.536 141.884ZM774.914 142.382V144.001C775.525 144.001 776.062 143.772 776.463 143.372C776.776 143.059 776.947 142.682 776.984 142.609L775.536 141.884L774.088 141.16C774.051 141.233 774.048 141.238 774.05 141.234C774.056 141.224 774.095 141.16 774.173 141.082C774.258 140.997 774.379 140.906 774.534 140.842C774.688 140.779 774.823 140.763 774.914 140.763V142.382Z"
          fill="#C90010"
        />
        <line x1="1348.16" y1="2.2959" x2="1348.16" y2="210.573" stroke="#C90010" strokeWidth="11.8168" />
        <circle cx="1221.89" cy="109.901" r="82.7513" stroke="#C90010" strokeWidth="11.8168" />
        <circle cx="380.98" cy="109.901" r="82.7513" stroke="#C90010" strokeWidth="11.8168" />
      </svg>
    ),
  },
];

const correctOrder = [2, 4, 1, 3];

export const Question3 = ({ onAnswerSelected, handleIncorrect }: Question3Props): React.ReactElement => {
  const [correctSelections, setCorrectSelections] = useState<number[]>([]);
  const [errorSelections, setErrorSelections] = useState<number[]>([]);
  const [showFeedback, setShowFeedback] = useState(false);
  const [isCompleted, setIsCompleted] = useState(false);
  const [consecutiveErrors, setConsecutiveErrors] = useState(0);
  const [errorFeedback, setErrorFeedback] = useState<React.ReactNode>('');
  const feedbackTimeoutRef = React.useRef<NodeJS.Timeout | null>(null);

  const handleOptionClick = (optionId: number) => {
    if (isCompleted || correctSelections.includes(optionId) || errorSelections.includes(optionId)) return;

    const expectedNext = correctOrder[correctSelections.length];

    if (optionId === expectedNext) {
      const newCorrectSelections = [...correctSelections, optionId];
      setCorrectSelections(newCorrectSelections);
      setErrorSelections([]);
      setConsecutiveErrors(0);
      setErrorFeedback('');

      if (newCorrectSelections.length === 4) {
        setIsCompleted(true);
        setShowFeedback(true);
        onAnswerSelected(true);

        //Limpiamos el timeout antiguo
        if (feedbackTimeoutRef.current) {
          clearTimeout(feedbackTimeoutRef.current);
        }

        feedbackTimeoutRef.current = setTimeout(() => {
          setShowFeedback(false);
        }, 4000);
      }
    } else {
      setErrorSelections([...errorSelections, optionId]);
      const newErrorCount = consecutiveErrors + 1;
      setConsecutiveErrors(newErrorCount);

      let feedbackText;
      if (newErrorCount === 1) {
        feedbackText = (
          <>
            <strong>¡Casi lo tienes!</strong>
            <br />
            Prueba con otra parrilla.
          </>
        );
      } else if (newErrorCount >= 2) {
        feedbackText = (
          <>
            <strong>Tampoco, pero aquí va una pista:</strong>
            <br />
            los faros se van estilizando con los años.
          </>
        );
      }

      setErrorFeedback(feedbackText);
      setShowFeedback(true);

      //Limpiamos el timeout antiguo
      if (feedbackTimeoutRef.current) {
        clearTimeout(feedbackTimeoutRef.current);
      }

      feedbackTimeoutRef.current = setTimeout(() => {
        setShowFeedback(false);
        setErrorFeedback('');
      }, 3000);

      handleIncorrect();
    }
  };

  const getOrderNumber = (optionId: number) => {
    const index = correctSelections.indexOf(optionId);
    return index !== -1 ? index + 1 : undefined;
  };

  const isError = (optionId: number) => errorSelections.includes(optionId);
  const isCorrect = (optionId: number) => correctSelections.includes(optionId);
  const isSelected = (optionId: number) => correctSelections.includes(optionId) || errorSelections.includes(optionId);

  const getFeedbackText = () => {
    if (errorFeedback) {
      return errorFeedback;
    }

    if (!isCompleted) return null;

    return (
      <>
        <strong>¡Lo tienes!</strong>
        <br />
        Así se ordena medio siglo de GTI.
      </>
    );
  };

  return (
    <Container
      horizontalAlign={'center'}
      wrap={'always'}
      gutter={ContainerGutter.static350}
      padding={{
        top: ContainerGutter.dynamic0050,
        left: ContainerGutter.static400,
        right: ContainerGutter.static400,
      }}
    >
      <DescriptionText appearance={TokenTextAppearance.headline200}>
        Para terminar, ordena estas 4 generaciones.
      </DescriptionText>
      <SecondaryText appearance={TokenTextAppearance.headline200}>
        Haz clic en los faros del más antiguo al más nuevo.
      </SecondaryText>

      <OptionsWrapper>
        <OptionsContainer>
          {options.map((option) => (
            <OptionWrapper key={option.id}>
              <SvgContainer
                selected={isSelected(option.id)}
                order={getOrderNumber(option.id)}
                isError={isError(option.id)}
                isCorrect={isCorrect(option.id)}
                onClick={() => handleOptionClick(option.id)}
              >
                {option.svg}
              </SvgContainer>
              <OptionText appearance={TokenTextAppearance.copy100} visible={isCorrect(option.id)}>
                {option.text}
              </OptionText>
            </OptionWrapper>
          ))}
        </OptionsContainer>

        <FeedbackContainer>
          {showFeedback && (
            <FeedbackText appearance={TokenTextAppearance.headline100}>{getFeedbackText()}</FeedbackText>
          )}
        </FeedbackContainer>
      </OptionsWrapper>
    </Container>
  );
};
